import { environment } from '../../../environments/environment';
export const URL_DIR = 'http://pruebas.appjockeyplaza.pe:81/dd';
export const URL_APP = 'http://pruebas.appjockeyplaza.pe:81/api';
export const URL_LOCAL = 'http://localhost:3000';
export const TIME_RENDER_CARD = environment.timeRenderCards || 3000;
export const URL_BACKEND = environment.api_url + '/api';
